import type { GraphQLResponse, Observer } from 'relay-runtime';

import { type NoNetworkError } from '@confluence/network';
import { fg } from '@confluence/feature-gating';
import { ClientNetworkStatus } from '@confluence/legacy-schema-bridge/entry-points/useNetworkStatusListenerCache.ts';

import {
	isIpBlockedError,
	isRateLimitedError,
	shouldTreatAsOfflineError,
} from './networkStatusMiddlewareUtils.ts';

export interface ErrorHandler<T extends Error = Error> {
	check: (error: Error) => error is T;
	status: ClientNetworkStatus;
	logMessage: string;
	propagateError: boolean;
	conditionalPropagate?: (error: T, observer: Observer<GraphQLResponse>) => void;
}

export const ERROR_HANDLERS: ReadonlyArray<ErrorHandler> = [
	{
		check: isIpBlockedError,
		status: ClientNetworkStatus.IP_BLOCKED,
		logMessage: 'IP blocked',
		propagateError: false,
	},
	{
		check: isRateLimitedError,
		status: ClientNetworkStatus.RATE_LIMITED,
		logMessage: 'Rate limit was reached',
		propagateError: true,
	},
	{
		check: shouldTreatAsOfflineError,
		status: ClientNetworkStatus.OFFLINE,
		logMessage: 'Network is offline',
		propagateError: false,
		conditionalPropagate: (error: NoNetworkError, observer: Observer<GraphQLResponse>) => {
			if (!fg('platform_editor_bubble_cfe_gql_network_errors')) {
				// Error swallowed - intentionally leave Observable hanging (matches Apollo behavior)
				return;
			}
			error.wasBubbledUp = true;
			observer.error?.(error);
		},
	},
];
